/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface ICardHeaderProps {
	className?: string;
	title?: React.ReactNode;
	subheader?: React.ReactNode;
	action?: React.ReactNode;
}

export const CardHeader: React.FC<ICardHeaderProps> = ({ className, children, title, subheader, action }) => {
	const baseClass = BEM("edt-card-header");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("content").toClassName()}>
				{title && <div className={baseClass.element("title").toClassName()}>{title}</div>}
				{subheader && <div className={baseClass.element("subheader").toClassName()}>{subheader}</div>}
				{children}
			</div>
			{action && <div className={baseClass.element("action").toClassName()}>{action}</div>}
		</div>
	);
};
